import type { Appearance } from "@clerk/types";

export const clerkDarkTheme: Appearance = {
	variables: {
		colorPrimary: "#ea580c",
		colorNeutral: "#FAFAFA",
		colorBackground: "#121212",
		colorInput: "#1A1A1A",
		colorInputForeground: "#FAFAFA",
		colorForeground: "#FAFAFA",
		colorMutedForeground: "#A1A1AA",
		colorBorder: "rgba(255, 255, 255, 0.1)",
		borderRadius: "0.75rem",
		fontFamily: "'Inter', system-ui, sans-serif",
	},
	elements: {
		card: "bg-[#121212] border border-white/10 shadow-2xl",
		formButtonPrimary: "bg-[#ea580c] hover:bg-[#c2410c] text-white",
		footerActionLink: "text-[#ea580c] hover:text-[#f97316]",
		formFieldInput: "bg-[#1A1A1A] border-white/10 text-[#FAFAFA]",
		headerTitle: "text-[#FAFAFA]",
		headerSubtitle: "text-[#A1A1AA]",
		socialButtonsBlockButton: "bg-[#1A1A1A] border-white/10 text-[#FAFAFA] hover:bg-[#242424]",
	},
};
